export default "__VITE_ASSET__hCm21GO6__"